// extracted by mini-css-extract-plugin
export var sectionWrapper = "statistics-module--section-wrapper--7E9op";